import React, { useMemo } from 'react';

import { ToggleSwitch } from '@eika/toggle-switch';

import { getTitleDic } from '../../functions';
import { CardControlLoader, Piwik, RegionRule, RegionWarning, SiteCoreDictionary } from '../../types';
import WarningDisplay from '../warningDisplay/WarningDisplay';

interface RegionToggleProps {
    regionRule: RegionRule;
    warning: RegionWarning | null;
    cardControlLoader: CardControlLoader;
    updateEnabledRegions: (regionRule: RegionRule, enable: boolean) => void;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

export default ({
    regionRule,
    warning,
    cardControlLoader,
    updateEnabledRegions,
    dictionary,
    piwik,
}: RegionToggleProps) => {
    const { isPostingCardControl, isFetchingCardControl } = cardControlLoader;
    const { region, enabled } = regionRule;

    const toggleSwitchText: string = useMemo(() => {
        const titleName = getTitleDic(dictionary);

        if (typeof titleName[region.id] !== 'undefined') {
            return titleName[region.id];
        }

        return region.name;
    }, [dictionary, region.id, region.name]);

    return (
        <div className="toggleContainer" key={region.id}>
            <div className="toggleRow">
                <p>{toggleSwitchText}</p>
                <ToggleSwitch
                    checked={enabled}
                    onChange={(value) => updateEnabledRegions(regionRule, value)}
                    disabled={isPostingCardControl || isFetchingCardControl}
                    ariaLabel={region.name}
                    switchText={['Aktivert', 'Sperret']}
                />
            </div>
            <WarningDisplay region={region} warning={warning} piwik={piwik} />
        </div>
    );
};
